import { render, staticRenderFns } from "./offer-block.vue?vue&type=template&id=3d13fd8e"
import script from "./offer-block.vue?vue&type=script&lang=js"
export * from "./offer-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports